/**
 * P3-PROPOSAL — Arial (Liberation Sans) advance widths, em/1000.
 * Auto-generated from the rebuilt subsets; DO NOT EDIT.
 */

export const ARIAL_W: Record<'regular' | 'medium' | 'bold', Record<string, number>> = {
  "regular": {
    "32": 277.8,
    "33": 277.8,
    "34": 355.0,
    "35": 556.2,
    "36": 556.2,
    "37": 889.2,
    "38": 667.0,
    "39": 190.9,
    "40": 333.0,
    "41": 333.0,
    "42": 389.2,
    "43": 584.0,
    "44": 277.8,
    "45": 333.0,
    "46": 277.8,
    "47": 277.8,
    "48": 556.2,
    "49": 556.2,
    "50": 556.2,
    "51": 556.2,
    "52": 556.2,
    "53": 556.2,
    "54": 556.2,
    "55": 556.2,
    "56": 556.2,
    "57": 556.2,
    "58": 277.8,
    "59": 277.8,
    "60": 584.0,
    "61": 584.0,
    "62": 584.0,
    "63": 556.2,
    "64": 1015.1,
    "65": 667.0,
    "66": 667.0,
    "67": 722.2,
    "68": 722.2,
    "69": 667.0,
    "70": 610.8,
    "71": 777.8,
    "72": 722.2,
    "73": 277.8,
    "74": 500.0,
    "75": 667.0,
    "76": 556.2,
    "77": 833.0,
    "78": 722.2,
    "79": 777.8,
    "80": 667.0,
    "81": 777.8,
    "82": 722.2,
    "83": 667.0,
    "84": 610.8,
    "85": 722.2,
    "86": 667.0,
    "87": 943.8,
    "88": 667.0,
    "89": 667.0,
    "90": 610.8,
    "91": 277.8,
    "92": 277.8,
    "93": 277.8,
    "94": 469.2,
    "95": 556.2,
    "96": 333.0,
    "97": 556.2,
    "98": 556.2,
    "99": 500.0,
    "100": 556.2,
    "101": 556.2,
    "102": 277.8,
    "103": 556.2,
    "104": 556.2,
    "105": 222.2,
    "106": 222.2,
    "107": 500.0,
    "108": 222.2,
    "109": 833.0,
    "110": 556.2,
    "111": 556.2,
    "112": 556.2,
    "113": 556.2,
    "114": 333.0,
    "115": 500.0,
    "116": 277.8,
    "117": 556.2,
    "118": 500.0,
    "119": 722.2,
    "120": 500.0,
    "121": 500.0,
    "122": 500.0,
    "123": 334.0,
    "124": 259.8,
    "125": 334.0,
    "126": 584.0
  },
  "medium": {
    "32": 277.8,
    "33": 277.8,
    "34": 355.0,
    "35": 556.2,
    "36": 556.2,
    "37": 889.2,
    "38": 667.0,
    "39": 190.9,
    "40": 333.0,
    "41": 333.0,
    "42": 389.2,
    "43": 584.0,
    "44": 277.8,
    "45": 333.0,
    "46": 277.8,
    "47": 277.8,
    "48": 556.2,
    "49": 556.2,
    "50": 556.2,
    "51": 556.2,
    "52": 556.2,
    "53": 556.2,
    "54": 556.2,
    "55": 556.2,
    "56": 556.2,
    "57": 556.2,
    "58": 277.8,
    "59": 277.8,
    "60": 584.0,
    "61": 584.0,
    "62": 584.0,
    "63": 556.2,
    "64": 1015.1,
    "65": 667.0,
    "66": 667.0,
    "67": 722.2,
    "68": 722.2,
    "69": 667.0,
    "70": 610.8,
    "71": 777.8,
    "72": 722.2,
    "73": 277.8,
    "74": 500.0,
    "75": 667.0,
    "76": 556.2,
    "77": 833.0,
    "78": 722.2,
    "79": 777.8,
    "80": 667.0,
    "81": 777.8,
    "82": 722.2,
    "83": 667.0,
    "84": 610.8,
    "85": 722.2,
    "86": 667.0,
    "87": 943.8,
    "88": 667.0,
    "89": 667.0,
    "90": 610.8,
    "91": 277.8,
    "92": 277.8,
    "93": 277.8,
    "94": 469.2,
    "95": 556.2,
    "96": 333.0,
    "97": 556.2,
    "98": 556.2,
    "99": 500.0,
    "100": 556.2,
    "101": 556.2,
    "102": 277.8,
    "103": 556.2,
    "104": 556.2,
    "105": 222.2,
    "106": 222.2,
    "107": 500.0,
    "108": 222.2,
    "109": 833.0,
    "110": 556.2,
    "111": 556.2,
    "112": 556.2,
    "113": 556.2,
    "114": 333.0,
    "115": 500.0,
    "116": 277.8,
    "117": 556.2,
    "118": 500.0,
    "119": 722.2,
    "120": 500.0,
    "121": 500.0,
    "122": 500.0,
    "123": 334.0,
    "124": 259.8,
    "125": 334.0,
    "126": 584.0
  },
  "bold": {
    "32": 277.8,
    "33": 333.0,
    "34": 474.1,
    "35": 556.2,
    "36": 556.2,
    "37": 889.2,
    "38": 722.2,
    "39": 237.8,
    "40": 333.0,
    "41": 333.0,
    "42": 389.2,
    "43": 584.0,
    "44": 277.8,
    "45": 333.0,
    "46": 277.8,
    "47": 277.8,
    "48": 556.2,
    "49": 556.2,
    "50": 556.2,
    "51": 556.2,
    "52": 556.2,
    "53": 556.2,
    "54": 556.2,
    "55": 556.2,
    "56": 556.2,
    "57": 556.2,
    "58": 333.0,
    "59": 333.0,
    "60": 584.0,
    "61": 584.0,
    "62": 584.0,
    "63": 610.8,
    "64": 975.1,
    "65": 722.2,
    "66": 722.2,
    "67": 722.2,
    "68": 722.2,
    "69": 667.0,
    "70": 610.8,
    "71": 777.8,
    "72": 722.2,
    "73": 277.8,
    "74": 556.2,
    "75": 722.2,
    "76": 610.8,
    "77": 833.0,
    "78": 722.2,
    "79": 777.8,
    "80": 667.0,
    "81": 777.8,
    "82": 722.2,
    "83": 667.0,
    "84": 610.8,
    "85": 722.2,
    "86": 667.0,
    "87": 943.8,
    "88": 667.0,
    "89": 667.0,
    "90": 610.8,
    "91": 333.0,
    "92": 277.8,
    "93": 333.0,
    "94": 584.0,
    "95": 556.2,
    "96": 333.0,
    "97": 556.2,
    "98": 610.8,
    "99": 556.2,
    "100": 610.8,
    "101": 556.2,
    "102": 333.0,
    "103": 610.8,
    "104": 610.8,
    "105": 277.8,
    "106": 277.8,
    "107": 556.2,
    "108": 277.8,
    "109": 889.2,
    "110": 610.8,
    "111": 610.8,
    "112": 610.8,
    "113": 610.8,
    "114": 389.2,
    "115": 556.2,
    "116": 333.0,
    "117": 610.8,
    "118": 556.2,
    "119": 777.8,
    "120": 556.2,
    "121": 556.2,
    "122": 500.0,
    "123": 389.2,
    "124": 279.8,
    "125": 389.2,
    "126": 584.0
  },
};
